import { render } from "./Bulk.vue?vue&type=template&id=482a5856"
import script from "./Bulk.vue?vue&type=script&lang=js"
export * from "./Bulk.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__